$(document).ready(function () {
  const log = window.log;
  function waitForEl(selector, cb, attr, interval, timeout) {
    interval = interval || 100;
    timeout = timeout || 10000;
    let t = 0;
    const intv = setInterval(function () {
      const $el = $(selector);
      if ($el.length && (!attr || $el.attr(attr))) {
        clearInterval(intv);
        cb($el);
      } else if ((t += interval) >= timeout) {
        clearInterval(intv);
      }
    }, interval);
  }

  log("Kachign Bundle Offer script loaded")

  waitForEl('kaching-bundles-block', function ($el) {
    const deal = JSON.parse($el.attr('deal-block') || '{}');
    const atcBtn = $('.na_atc_btn, .pdp-kaching-atc__btn');
    const errorNote = $('.na_atc_error_note, .pdp-kaching-atc__error-note');

    log.collapse(deal, 'Deal', 'info');

    function checkSelectedDealBar() {
      const $selectedDealBar = $('.kaching-bundles__bar--selected');
      if ($selectedDealBar.length === 0) {
        atcBtn.prop('disabled', false);
        errorNote.hide();
        return;
      }

      const $collectionItems = $selectedDealBar.find('.kaching-bundles__collection-product');
      const isCollectionDealBar = $selectedDealBar.find('.kaching-bundles__bar-collection-products').length > 0 && $collectionItems.length > 0;

      if (!isCollectionDealBar) {
        atcBtn.prop('disabled', false);
        errorNote.hide();
        return;
      }

      const allProductsChosen = $collectionItems.toArray().every(function (item) {
        const $button = $(item).find('.kaching-bundles__collection-product__choose-product-button');
        return $button.length === 0 || !$button.is(':visible');
      });

      atcBtn.prop('disabled', !allProductsChosen);
      errorNote.toggle(!allProductsChosen);
    }

    // Helper to check if node contains choose button
    function hasChooseButton(node) {
      if (node.nodeType !== 1) return false;
      const $node = $(node);
      return $node.hasClass('kaching-bundles__collection-product__choose-product-button') ||
        $node.find('.kaching-bundles__collection-product__choose-product-button').length > 0;
    }

    // Set up listeners for all deal bars
    $.each(deal.dealBars || [], function (_, dealBar) {
      const $dealBar = $(`.kaching-bundles__bar[data-deal-bar-id="${dealBar.id}"]`);
      if ($dealBar.length === 0) return;

      $dealBar.on('click', () => setTimeout(checkSelectedDealBar, 50));

      const $collectionItems = $dealBar.find('.kaching-bundles__collection-product');
      $collectionItems.each(function () {
        const itemEl = this;
        $(this).on('click', '.kaching-bundles__collection-product__choose-product-button', function () {
          const observer = new MutationObserver(function (mutations) {
            const hasChange = mutations.some(function (m) {
              const removed = Array.from(m.removedNodes || []).some(hasChooseButton);
              const added = Array.from(m.addedNodes || []).some(n => n.nodeType === 1);
              return removed || added;
            });
            if (hasChange) {
              setTimeout(checkSelectedDealBar, 100);
              observer.disconnect();
            }
          });
          observer.observe(itemEl, { childList: true, subtree: true });
          setTimeout(() => { checkSelectedDealBar(); observer.disconnect(); }, 500);
        });
        $(this).on('change', () => setTimeout(checkSelectedDealBar, 50));
      });

      const $collectionProducts = $dealBar.find('.kaching-bundles__bar-collection-products');
      if ($collectionProducts.length > 0) {
        const observer = new MutationObserver(function (mutations) {
          if (!$dealBar.hasClass('kaching-bundles__bar--selected')) return;
          const hasChange = mutations.some(function (m) {
            if (m.type !== 'childList') return false;
            const removed = Array.from(m.removedNodes || []).some(hasChooseButton);
            const added = Array.from(m.addedNodes || []).some(n => n.nodeType === 1);
            return removed || added;
          });
          if (hasChange) setTimeout(checkSelectedDealBar, 100);
        });
        $collectionProducts.each(function () {
          observer.observe(this, { childList: true, subtree: true });
        });
      }
    });

    // Watch for deal bar selection changes
    const dealBarObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class' && $(m.target).hasClass('kaching-bundles__bar--selected')) {
          checkSelectedDealBar();
        }
      });
    });
    $('.kaching-bundles__bar').each(function () {
      dealBarObserver.observe(this, { attributes: true, attributeFilter: ['class'] });
    });

    // Listen for modal/product interactions
    $(document).on('click', '.kaching-bundles__collection-product, [data-modal], .modal', () => setTimeout(checkSelectedDealBar, 200));
    $(document).on('hidden.bs.modal closed.bs.modal modal:close', () => setTimeout(checkSelectedDealBar, 100));

    // Periodic fallback check
    setInterval(() => {
      if ($('.kaching-bundles__bar--selected').length > 0) checkSelectedDealBar();
    }, 500);

    checkSelectedDealBar();

  }, 'deal-block');
});